const Swiper = require("swiper").default;

export default class {
    constructor()
    {
        new Swiper('.swiper-container.promos-home', {
            slidesPerView: '3',
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });     
    }
}